module.exports = __webpack_public_path__ + "static/media/vfx3.fca018e9.jpg";